import { useState } from "react";

import EyeIcon from "../../../assets/img/eye-icon.png";
import { ConstructionPeriodLabel, IDwelling } from "../reducers";

interface IDwellingBadgeComponentProps {
  dwelling: IDwelling;
  viewMore: boolean;
  setShowModal?: (value: boolean) => void;
}

const DwellingDetailBadgesComponent: React.FC<IDwellingBadgeComponentProps> = ({
  dwelling,
  viewMore,
  setShowModal,
}) => {
  const [, setInternalShowModal] = useState<boolean>(false);
  const modalSetter = setShowModal || setInternalShowModal;

  return (
    <div className="d-flex flex-wrap gap-2 badges-address">
      <span className="badge badge-primary-light">
        {dwelling.isFurnished ? "Meublé" : "Non Meublé"}
      </span>
      {dwelling?.category?.label && (
        <span className="badge badge-primary-light">
          {dwelling.category.label}
        </span>
      )}
      {dwelling?.type?.label && (
        <span className="badge badge-primary-light">{dwelling.type.label}</span>
      )}
      {dwelling?.area && (
        <span className="badge badge-primary-light">{dwelling.area} m²</span>
      )}
      {dwelling?.address?.floor && (
        <span className="badge badge-primary-light">
          {dwelling.address.floor}{" "}
          {Number(dwelling.address.floor) > 1 ? <sup>ème</sup> : <sup>er</sup>}{" "}
          étage
        </span>
      )}
      {dwelling?.managementLotNumber && (
        <span className="badge badge-primary-light">
          N° lot {dwelling.managementLotNumber}
        </span>
      )}
      {dwelling?.constructionPeriod?.value && (
        <span className="badge badge-primary-light">
          Construction :{" "}
          {ConstructionPeriodLabel[
            dwelling?.constructionPeriod
              ?.value as keyof typeof ConstructionPeriodLabel
          ].toLowerCase()}
        </span>
      )}
      {viewMore && (
        <a className="d-flex" href="#">
          <img
            src={EyeIcon}
            alt="Icone oeil"
            onClick={() => modalSetter(true)}
          />
        </a>
      )}
    </div>
  );
};

export default DwellingDetailBadgesComponent;
